/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Target type for the notification
 */
export enum ApplicationEventNotificationTemplateType {
    INTERNAL = 'INTERNAL',
    CLIENT = 'CLIENT',
}
